module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ServiceStoreDetailsView.js"));
	}, "ServiceStoreDetailsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ServiceStoreDetailsView!./src/pages/Shop/Member/Personal/ServiceCode/ServiceStoreDetails/ServiceStoreDetailsView.js
// module id = 1899
// module chunks = 367